export * from './FluentColors';
export { DefaultPalette } from './DefaultPalette';
//# sourceMappingURL=index.js.map